/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { useFieldSectionContext } from "../../../contexts/FieldSectionContext";
import { ButtonBase } from "../../core";

import "./FieldSectionExpander.scss";

export interface IFieldSectionExpanderProps {
	children?: React.ReactNode;
	className?: string;
}

const FieldSectionExpander: React.FC<IFieldSectionExpanderProps> = ({ children, className }) => {
	const fieldSectionCtx = useFieldSectionContext();

	const baseClass = BEM("edt-field-section-expander", null, {
		collapsed: fieldSectionCtx?.collapsed
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<ButtonBase className={baseClass.toClassName()} onClick={fieldSectionCtx?.toggleCollapsed}>
			{children}
		</ButtonBase>
	);
};

const FieldSectionExpanderMemo = React.memo(FieldSectionExpander);

export { FieldSectionExpanderMemo as FieldSectionExpander };
